module.exports = __webpack_public_path__ + "img/graph-image-ar.6a09979a.png";